import { formatDate } from "utils/utils.js";
import { CIPHistoricMembrane } from "constants/constantStrings";
import { LOCAL_TZ_CODE } from "constants/globalConstants";

const HISTORIC_MEMBRANE_TABLE_COLUMNS = [
  {
    field: "Id",
    headerName: CIPHistoricMembrane.id,
    flex: 1
  },
  {
    field: "Start_Time",
    headerName: CIPHistoricMembrane.startTime,
    flex: 1,
    valueFormatter: params => `${formatDate(params.data.Start_Time)} ${LOCAL_TZ_CODE}`,
  },
  {
    field: "End_Time",
    headerName: CIPHistoricMembrane.endTime,
    flex: 1,
    valueFormatter: params => `${formatDate(params.data.End_Time)} ${LOCAL_TZ_CODE}`,
  }
];

export default HISTORIC_MEMBRANE_TABLE_COLUMNS;
